import { FC, useEffect, useState } from 'react'
import { copyToClipboard } from '../utils'

const COPIED_MS = 1200

// Nameserver value; clicking the row or the icon copies it
const NameserverRow: FC<{ value: string }> = ({ value }) => {
 const [copied, setCopied] = useState(false)

 useEffect(() => {
  if (!copied) return undefined
  const id = setTimeout(() => setCopied(false), COPIED_MS)
  return () => clearTimeout(id)
 }, [copied])

 const onCopy = (): void => {
  copyToClipboard(value)
  setCopied(true)
 }

 return (
  <button
   type="button"
   className={`ns-row ${copied ? 'copied' : ''}`}
   aria-label={`Copy ${value}`}
   onClick={onCopy}
  >
   <span className="val">{value}</span>
   <i className={copied ? 'fas fa-check' : 'far fa-copy'} />
  </button>
 )
}

export default NameserverRow
